(function() {

  /* ── DESKTOP FILTER DROPDOWNS ── */
  var fds       = document.querySelectorAll('.ys-col-fd');
  var sortBtn   = document.getElementById('ys-sort-btn');
  var sortPanel = document.getElementById('ys-sort-panel');

  function closeAllDesktop() {
    fds.forEach(function(fd) {
      var btn   = fd.querySelector('.ys-col-fd__btn');
      var panel = fd.querySelector('.ys-col-panel');
      if (btn)   { btn.classList.remove('ys-open'); btn.setAttribute('aria-expanded', 'false'); }
      if (panel) panel.classList.remove('ys-open');
    });
    if (sortBtn)   { sortBtn.classList.remove('ys-open'); sortBtn.setAttribute('aria-expanded', 'false'); }
    if (sortPanel) sortPanel.classList.remove('ys-open');
  }

  fds.forEach(function(fd) {
    var btn   = fd.querySelector('.ys-col-fd__btn');
    var panel = fd.querySelector('.ys-col-panel');
    if (!btn || !panel) return;
    btn.addEventListener('click', function(e) {
      e.stopPropagation();
      var isOpen = btn.classList.contains('ys-open');
      closeAllDesktop();
      if (!isOpen) {
        btn.classList.add('ys-open');
        btn.setAttribute('aria-expanded', 'true');
        panel.classList.add('ys-open');
      }
    });
  });

  if (sortBtn && sortPanel) {
    sortBtn.addEventListener('click', function(e) {
      e.stopPropagation();
      var isOpen = sortBtn.classList.contains('ys-open');
      closeAllDesktop();
      if (!isOpen) {
        sortBtn.classList.add('ys-open');
        sortBtn.setAttribute('aria-expanded', 'true');
        sortPanel.classList.add('ys-open');
      }
    });
  }

  document.addEventListener('click', closeAllDesktop);

  /* ── MOBILE FILTER DRAWER ── */
  var mobileBtn   = document.getElementById('ys-mobile-filter-btn');
  var drawer      = document.getElementById('ys-col-drawer');
  var drawerClose = document.getElementById('ys-drawer-close');
  var drawerView  = document.getElementById('ys-drawer-view');
  var backdrop    = document.getElementById('ys-drawer-backdrop');
  var _countTimer = null;
  var _countCtrl  = null;

  /* ── LIVE PRODUCT COUNT ──
     Debounced fetch against the pending URL; parses the product total
     and updates the "View X products" button. */
  function fetchPendingCount() {
    if (_countTimer) clearTimeout(_countTimer);
    if (_countCtrl) { try { _countCtrl.abort(); } catch(e) {} }
    if (drawerView) drawerView.textContent = 'Checking…';
    _countTimer = setTimeout(function() {
      _countCtrl = new AbortController();
      fetch(buildURL(), { signal: _countCtrl.signal })
        .then(function(r) { return r.text(); })
        .then(function(html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var moreEl = doc.getElementById('ys-col-more');
          var gridEl = doc.getElementById('ys-col-grid');
          var count = 0;
          if (moreEl) count = parseInt(moreEl.getAttribute('data-total'), 10) || 0;
          else if (gridEl) count = gridEl.querySelectorAll('.ys-product-card').length;
          if (drawerView) {
            drawerView.textContent = count === 0
              ? 'No products found'
              : 'View ' + count + ' product' + (count === 1 ? '' : 's');
          }
        })
        .catch(function() {
          if (drawerView) drawerView.textContent = 'View products';
        });
    }, 300);
  }

  /* ── PENDING FILTER STATE ──
     Holds all pending URL params as { key: [val, val, …] }.
     Filter opts are toggled in-memory; navigation happens only
     when the user taps "View products". */
  var pendingParams = {};

  function initPending() {
    var sp = new URLSearchParams(window.location.search);
    pendingParams = {};
    sp.forEach(function(val, key) {
      if (!pendingParams[key]) pendingParams[key] = [];
      pendingParams[key].push(val); // URLSearchParams decodes values
    });
  }

  function buildURL() {
    var sp = new URLSearchParams();
    Object.keys(pendingParams).sort().forEach(function(key) {
      (pendingParams[key] || []).forEach(function(val) {
        sp.append(key, val);
      });
    });
    var qs = sp.toString();
    return window.location.pathname + (qs ? '?' + qs : '');
  }

  function countActiveFilters() {
    var n = 0;
    Object.keys(pendingParams).forEach(function(key) {
      if (key !== 'sort_by') n += (pendingParams[key] || []).length;
    });
    return n;
  }

  function syncDrawerVisuals() {
    if (!drawer) return;

    // 1. Filter checkboxes
    drawer.querySelectorAll('.ys-col-drawer__opt[data-param]').forEach(function(opt) {
      var param   = opt.getAttribute('data-param');
      var val     = opt.getAttribute('data-val') || '';
      var checked = (pendingParams[param] || []).indexOf(val) > -1;
      opt.classList.toggle('ys-checked', checked);
      opt.setAttribute('aria-checked', checked ? 'true' : 'false');
    });

    // 2. Sort radios
    var currentSort = (pendingParams['sort_by'] || [])[0] || '';
    drawer.querySelectorAll('.ys-col-drawer__sort-row').forEach(function(row) {
      var isDefault = row.getAttribute('data-sort-default') === 'true';
      var rowSort   = row.getAttribute('data-sort') || '';
      var active    = isDefault ? currentSort === '' : rowSort === currentSort;
      row.classList.toggle('ys-active', active);
      row.setAttribute('aria-checked', active ? 'true' : 'false');
    });

    // 3. Per-section badge counts
    drawer.querySelectorAll('.ys-col-drawer__sec').forEach(function(sec) {
      var badge    = sec.querySelector('.ys-col-drawer__sec-hd .ys-col-mobile-badge');
      var firstOpt = sec.querySelector('.ys-col-drawer__opt[data-param]');
      if (!badge || !firstOpt) return;
      var param = firstOpt.getAttribute('data-param');
      var n     = (pendingParams[param] || []).length;
      badge.textContent = n;
      badge.classList.toggle('ys-hidden', n === 0);
    });

    // 4. View-products button label (live count via fetch)
    fetchPendingCount();

    // 5. Clear-all button visibility
    var n = countActiveFilters();
    var clearBtn = drawer.querySelector('.ys-col-drawer__clear-btn');
    if (clearBtn) clearBtn.classList.toggle('ys-hidden', n === 0);
  }

  /* ── SHOW 5 / SEE MORE ── */
  function initShowMore() {
    if (!drawer) return;
    drawer.querySelectorAll('.ys-col-drawer__sec').forEach(function(sec) {
      var opts = Array.prototype.slice.call(sec.querySelectorAll('.ys-col-drawer__opt'));
      if (opts.length <= 5) return;
      var extra = opts.length - 5;

      // Hide items 6+
      for (var i = 5; i < opts.length; i++) opts[i].classList.add('ys-hidden');

      var expanded = false;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'ys-col-drawer__show-more';
      btn.textContent = 'Show ' + extra + ' more';

      btn.addEventListener('click', function() {
        expanded = !expanded;
        for (var j = 5; j < opts.length; j++) opts[j].classList.toggle('ys-hidden', !expanded);
        btn.textContent = expanded ? 'Show less' : 'Show ' + extra + ' more';
      });

      // Insert before price form if present, otherwise append
      var priceForm = sec.querySelector('form');
      if (priceForm) sec.insertBefore(btn, priceForm);
      else sec.appendChild(btn);
    });
  }

  /* ── OPEN / CLOSE ── */
  function openDrawer() {
    if (!drawer) return;
    initPending();
    syncDrawerVisuals();
    drawer.classList.add('ys-open');
    document.body.style.overflow = 'hidden';
    if (drawerClose) setTimeout(function() { drawerClose.focus(); }, 50);
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('ys-open');
    document.body.style.overflow = '';
    if (mobileBtn) mobileBtn.focus();
  }

  /* ── DRAWER EVENT DELEGATION ── */
  if (drawer) {
    drawer.addEventListener('click', function(e) {

      // Filter checkbox toggle
      var opt = e.target.closest('.ys-col-drawer__opt[data-param]');
      if (opt) {
        e.preventDefault();
        var param = opt.getAttribute('data-param');
        var val   = opt.getAttribute('data-val') || '';
        var arr   = pendingParams[param] ? pendingParams[param].slice() : [];
        var idx   = arr.indexOf(val);
        if (idx > -1) arr.splice(idx, 1); else arr.push(val);
        if (arr.length) pendingParams[param] = arr; else delete pendingParams[param];
        syncDrawerVisuals();
        return;
      }

      // Sort row toggle (intercept, no navigate)
      var sortRow = e.target.closest('.ys-col-drawer__sort-row');
      if (sortRow) {
        e.preventDefault();
        if (sortRow.getAttribute('data-sort-default') === 'true') {
          delete pendingParams['sort_by'];
        } else {
          pendingParams['sort_by'] = [sortRow.getAttribute('data-sort')];
        }
        syncDrawerVisuals();
        return;
      }

      // Clear all (keep sort, reset filters)
      var clearBtn = e.target.closest('.ys-col-drawer__clear-btn');
      if (clearBtn) {
        e.preventDefault();
        Object.keys(pendingParams).forEach(function(key) {
          if (key !== 'sort_by') delete pendingParams[key];
        });
        syncDrawerVisuals();
        return;
      }
    });

    // View products → apply pending state and navigate
    if (drawerView) {
      drawerView.addEventListener('click', function() {
        window.location.href = buildURL();
      });
    }
  }

  if (mobileBtn)   mobileBtn.addEventListener('click', openDrawer);
  if (drawerClose) drawerClose.addEventListener('click', closeDrawer);
  if (backdrop)    backdrop.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('ys-open')) {
      closeDrawer();
    }
  });

  // Inject "Show more" buttons on page load
  initShowMore();

  /* ── AJAX LOAD MORE ── */
  var loadMoreBtn = document.getElementById('ys-load-more');
  var moreTxt     = document.getElementById('ys-more-txt');
  var moreFill    = document.getElementById('ys-more-fill');
  var moreWrap    = document.getElementById('ys-col-more');
  var grid        = document.getElementById('ys-col-grid');

  if (loadMoreBtn && grid && moreWrap) {
    var total = parseInt(moreWrap.getAttribute('data-total'), 10) || 0;

    loadMoreBtn.addEventListener('click', function() {
      var nextUrl = loadMoreBtn.getAttribute('data-next-url');
      if (!nextUrl) return;

      loadMoreBtn.disabled = true;
      loadMoreBtn.textContent = 'Loading…';

      fetch(nextUrl)
        .then(function(res) { return res.text(); })
        .then(function(html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');

          var newGrid = doc.getElementById('ys-col-grid');
          if (newGrid) {
            var cards = newGrid.querySelectorAll('.ys-product-card');
            cards.forEach(function(card, i) {
              card.classList.add('ys-card-enter');
              card.style.animationDelay = (i * 50) + 'ms';
              grid.appendChild(card);
            });
          }

          var nextBtn = doc.getElementById('ys-load-more');
          if (nextBtn && nextBtn.getAttribute('data-next-url')) {
            loadMoreBtn.setAttribute('data-next-url', nextBtn.getAttribute('data-next-url'));
            loadMoreBtn.disabled = false;
            loadMoreBtn.textContent = 'Load More Products';
          } else {
            loadMoreBtn.style.display = 'none';
          }

          var shownNow = grid.querySelectorAll('.ys-product-card').length;
          if (moreTxt) {
            moreTxt.textContent = shownNow >= total
              ? 'Showing all ' + total + ' products'
              : 'Showing ' + shownNow + ' of ' + total + ' products';
          }
          if (moreFill) {
            moreFill.style.width = Math.min(shownNow / total * 100, 100) + '%';
          }

          if (window.jdgm && window.jdgm.init) window.jdgm.init();
        })
        .catch(function() {
          loadMoreBtn.disabled = false;
          loadMoreBtn.textContent = 'Load More Products';
        });
    });
  }

})();
